import { MessageBalloonProps } from './types';

export const messagesBallons: MessageBalloonProps[] = [
  {
    id: 1,
    height: '60px',
    width: '20%',
    justifyContent: 'end',
    marginTop: '50px',
    borderRadius: '8px 0 8px 8px',
  },
  {
    id: 2,
    height: '100px',
    width: '20%',
    justifyContent: 'start',
    borderRadius: '8px 8px 8px 0',
  },
  {
    id: 3,
    height: '50px',
    width: '20%',
    justifyContent: 'start',
    borderRadius: '0 8px 8px 8px',
  },
  {
    id: 4,
    height: '60px',
    width: '20%',
    justifyContent: 'end',
    borderRadius: '8px 0 8px 8px',
  },
  {
    id: 5,
    height: '60px',
    width: '20%',
    justifyContent: 'end',
    borderRadius: '8px 0 8px 8px',
  },
  {
    id: 6,
    height: '60px',
    width: '20%',
    justifyContent: 'end',
    borderRadius: '8px 0 8px 8px',
  },
  {
    id: 7,
    height: '100px',
    width: '20%',
    justifyContent: 'start',
    borderRadius: '8px 8px 8px 0',
  },
  {
    id: 8,
    height: '50px',
    width: '20%',
    justifyContent: 'start',
    borderRadius: '0 8px 8px 8px',
  },
  {
    id: 9,
    height: '60px',
    width: '20%',
    justifyContent: 'end',
    borderRadius: '8px 0 8px 8px',
  },
];
